import React, { ReactNode } from 'react'

interface AdminContainerProps {
  children?: ReactNode; // ReactNode is the type for any React elements passed as children
  className?: string;   // Optional className prop
}
const AdminCointainer:React.FC<AdminContainerProps> = ({ children, className = '' }) => {
  return (
    <div
      className={`p-2 md:pt-[82px]  ${className}`}
    >
      {children}
    </div>
  )
}

export default AdminCointainer
